// @flow
import type {ActionType} from 'constants/flow/flowTypes';
import {PRODUCT} from 'constants/actions';

import type {UpsellType} from './upsellType';

const initialState = {
    data: [],
    status: 'fulfilled',
};

// TODO Rename this reducer to recently viewed reducer
/**
 * Get data for recently Viewed
 * @param {UpsellType} state Current state
 * @param {ActionType<UpsellType>} action Received action
 * @returns {UpsellType} state New state
 */
export default function upsell(
    state: UpsellType = initialState,
    action: ActionType<UpsellType>,
): UpsellType {
    switch (action.type) {
        case `${PRODUCT.GET_UPSELL}_FULFILLED`:
            return {...state, data: [...action.payload.data], status: 'fulfilled'};
        case `${PRODUCT.GET_UPSELL}_PENDING`:
            return {...state, status: 'pending'};
        default:
            return state;
    }
}
